import React from 'react';
const PlayIcon = () => {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M6.6665 12V9.62668C6.6665 6.68001 8.75317 5.47334 11.3065 6.94668L13.3665 8.13334L15.4265 9.32001C17.9798 10.7933 17.9798 13.2067 15.4265 14.68L13.3665 15.8667L11.3065 17.0533C8.75317 18.5267 6.6665 17.32 6.6665 14.3733V12Z", stroke: "#BBBBBB", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default PlayIcon;
